import styled from "styled-components";
import {
  spacing,
  borderRadius,
  layer,
  elevation,
  color,
  palette,
} from "@conserveit/blocks";
import { TYPOGRAPHY } from "../AppChrome/App.constants";

// NOTE: Must be used in a relatively positioned container
function openClose({ isOpen }) {
  return isOpen ? "block" : "none";
}
const $Menu = styled.div`
  display: ${openClose};
  position: absolute;
  border-radius: ${borderRadius.default};
  height: auto;
  min-width: 180px;
  z-index: ${layer.contextNavigation};
  background: ${color.pureWhite};
  box-shadow: ${elevation.contentNavigation};
  overflow: hidden;
  transform: translateY(${spacing.tight});
`;

const $Item = styled.div`
  a,
  button {
    display: block;
    padding: ${spacing.snug};
    font-size: 14px;
    border: none;
    outline: 0;
    background: none;
    text-align: left;
    color: ${color.theme.typography.ink};
    white-space: nowrap;
  }

  a:not([disabled]):hover,
  button:not([disabled]):hover {
    background: ${palette.neutral2};
    text-decoration: none;
  }

  &:last-child {
    border-bottom: none;
  }
`;

function selected({ isSelected }) {
  return isSelected
    ? `${TYPOGRAPHY.WEIGHTS.BOLD}`
    : `${TYPOGRAPHY.WEIGHTS.REGULAR}`;
}
const $ButtonItem = styled.button.attrs({ type: "button" })`
  display: block;
  margin: 0;
  width: 100%;
  padding: ${spacing.tight} ${spacing.snug};
  font-weight: ${selected};
  border: none;
  outline: 0;
  font-size: 12px;
  background: transparent;
  text-align: left;
  white-space: nowrap;

  &:not([disabled]):focus {
    outline: 0;
  }

  &:not([disabled]):hover {
    background: ${palette.neutral2};
  }
`;

const $MenuTitle = styled.span`
  display: block;
  border-bottom: 1px solid ${color.theme.divider.solid};
  padding: ${spacing.snug};
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  color: ${color.theme.icon.default};
  text-align: left;
`;

export { $Menu, $MenuTitle, $Item, $ButtonItem };
